import axios from 'axios';

export const API_BASE_URL = (
  process.env.REACT_APP_API_URL || 'http://localhost:3001'
).replace(/\/$/, '');

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
});

const buildAuthHeaders = () => {
  const token = localStorage.getItem('token');

  if (!token) return {};

  return {
    Authorization: `Bearer ${token}`,
  };
};

export const getAllProducts = (searchTerm = '') => {
  return api.get('/api/products', {
    params: {
      name: searchTerm || '',
    },
  });
};

export const getAllProductsForAdmin = (searchTerm = '') => {
  return api.get('/api/products/admin', {
    params: {
      name: searchTerm || '',
    },
    headers: buildAuthHeaders(),
  });
};

export const getProductBySlug = (slug) => {
  return api.get(`/api/products/slug/${encodeURIComponent(slug)}`);
};

export const createProduct = (formData) => {
  return api.post('/api/products', formData, {
    headers: buildAuthHeaders(),
  });
};

export const createDraftProduct = (draftData) => {
  return api.post('/api/products/drafts', draftData, {
    headers: buildAuthHeaders(),
  });
};

export const updateProduct = (id, formData) => {
  return api.put(`/api/products/${id}`, formData, {
    headers: buildAuthHeaders(),
  });
};

export const deleteProduct = (id) => {
  return api.delete(`/api/products/${id}`, {
    headers: buildAuthHeaders(),
  });
};

export const getAllCatalogs = () => {
  return api.get('/api/catalogs');
};

export const login = (loginData) => {
  return api.post('/api/auth/login', loginData);
};
